import {
  BeginCheckoutTrackName,
  LoginTrackName,
  PurchaseTrackName,
  SignUpTrackName,
  UpgradeTrackName,
} from '../helpers/trackName'

import { useTrackBeginCheckout } from './beginCheckout'
import { useTrackLogin } from './login'
import { useTrackPurchase } from './purchase'
import { useTrackSignUp } from './signUp'
import { useTrackUpgrade } from './upgrade'
import { useDefaultTrack } from './defaultTrack'

import type { TrackCoreEventProps } from './type'
import type { RouterOutputs } from '@/utils/api'
import type { TrackEventParamsInput } from '@loc/server/interface/track/trackEventParams.common'

export interface ITrackCoreProps {
  eventTracking: (
    params: TrackEventParamsInput,
  ) => Promise<RouterOutputs['event']['tracking']>
}

export function useTrackCore(props: ITrackCoreProps) {
  const eventHandlers = {
    [SignUpTrackName]: useTrackSignUp(props).trackEvent,
    [LoginTrackName]: useTrackLogin(props).trackEvent,
    [UpgradeTrackName]: useTrackUpgrade(props).trackEvent,
    [PurchaseTrackName]: useTrackPurchase(props).trackEvent,
    [BeginCheckoutTrackName]: useTrackBeginCheckout(props).trackEvent,
  } as const

  const defaultTrack = useDefaultTrack(props).trackEvent

  const trackCoreEvent = async (props: TrackCoreEventProps) => {
    const { commonParamsLatest, ...rest } = props
    const eventName = rest.name
    if (eventName in eventHandlers) {
      await eventHandlers[eventName as keyof typeof eventHandlers](props as any)
      return
    }

    await defaultTrack(props)
  }

  return {
    trackCoreEvent,
  }
}
